module.exports = __webpack_public_path__ + "static/img/WAIDA.1870e2b3.jpg";